import React, { useEffect } from 'react';
import Sidebar from 'src/components/common/Sidebar';
import RodeoEventLeaderBoardPage from 'src/components/events/rodeoLeaderBoard/rodeoEventLeaderBoardPage';
import { RODEO_PAGE_NAME, APPLICATION_NAME } from 'src/_config';

export default function RodeoEventLeaderBoardContainer() {

    useEffect(() => {
        const prevTitle = document.title
        document.title = `${APPLICATION_NAME} : Results`
        return () => {
            document.title = prevTitle
        }
    }, [])

    return (
        <React.Fragment>
            <Sidebar page={RODEO_PAGE_NAME.LEADERBOARD} />
            <section className="main-container">
                <RodeoEventLeaderBoardPage />
            </section>
        </React.Fragment>
    )
}
